import { render } from "./GivingForm2.vue?vue&type=template&id=0b882986&scoped=true"
import script from "./GivingForm2.vue?vue&type=script&lang=js"
export * from "./GivingForm2.vue?vue&type=script&lang=js"

import "./GivingForm2.vue?vue&type=style&index=0&id=0b882986&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b882986"]])

export default __exports__